module.exports = __webpack_public_path__ + "img/95-959041_dentist-tools-clip-art-espatula-de-fazer-unha.86532bbb.png";